import React,{Component} from 'react';

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import style from "../../components/Header/style";
class  UnAuthorized extends Component{
  render(){
    return(
  <Grid container alignItems={'center'} justify={'center'} style={{ paddingTop: '15%' }}>
    <img
      src="/images/logo.webp"
      alt="Cuisine Crafters"
      style={{
        maxHeight: 100
      }}
      onClick={() => {
        this.props.history.push("/")
      }}
    />
    <Grid item sm={12}>
      <p style={{ textAlign: 'center' }}>Your session has expired, please log in again to continue.</p>
    </Grid>
    <Button color={"primary"} variant={"contained"} style={{ color: 'white', textTransform: 'none', fontFamily: 'Poppins' }} onClick={()=>{
      this.props.history.push("/")
    }}>
      Back to home page
    </Button>
  </Grid>
    )
  }
}

export default UnAuthorized;
